var _linearGradient, _linearGradient2, _linearGradient3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterfaceDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 345.7,
    x2: 427.62,
    y1: 161.77,
    y2: 161.77
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef0f1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    gradientTransform: "matrix(-1 0 0 -1 1753.95 -1382.49)",
    gradientUnits: "userSpaceOnUse",
    x1: 1350.83,
    x2: 1378.29,
    y1: -1725.43,
    y2: -1725.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9afc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d8e5"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 112.92,
    x2: 139.11,
    xlinkHref: "#linear-gradient-2",
    y1: 130.51,
    y2: 130.51
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    isolation: "isolate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dead_device",
    "data-name": "Dead device"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#dee1ec",
    height: 238.43,
    rx: 14.37,
    width: 354.72,
    x: 72.9,
    y: 117.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.62 131.78v209.69a14.37 14.37 0 0 1 -14.37 14.37h-326a14.37 14.37 0 0 1 -14.35-14.37v-209.69a14.36 14.36 0 0 1 14.36-14.36h326a14.36 14.36 0 0 1 14.36 14.36z",
    fill: "#dee1ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.64 134.48h319.24v203.82h-319.24z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.62 131.78v73.71c-50.32 6.58-91.33-39-80-88.07h65.66a14.36 14.36 0 0 1 14.34 14.36z",
    fill: "url(#linear-gradient)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.13 355.84-27.47.04.02-25.88z",
    fill: "url(#linear-gradient-2)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.92 117.42h26.19v26.18z",
    fill: "url(#linear-gradient-3)",
    "mix-blend-mode": "multiply"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.05 385.2h-389.58a14.69 14.69 0 0 1 -14.69-14.69v-14.67h419v14.67a14.69 14.69 0 0 1 -14.73 14.69z",
    fill: "#dee1ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.88 368.13h-49.24a5.83 5.83 0 0 1 -5.83-5.83v-6.46h60.9v6.46a5.83 5.83 0 0 1 -5.83 5.83z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5e6175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m413.25 358.84h-326a17.38 17.38 0 0 1 -17.35-17.36v-209.7a17.38 17.38 0 0 1 17.37-17.36h326a17.38 17.38 0 0 1 17.37 17.36v209.7a17.38 17.38 0 0 1 -17.39 17.36zm-326-238.42a11.38 11.38 0 0 0 -11.35 11.36v209.7a11.38 11.38 0 0 0 11.37 11.36h326a11.38 11.38 0 0 0 11.37-11.36v-209.7a11.38 11.38 0 0 0 -11.37-11.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.05 388.2h-389.58a17.72 17.72 0 0 1 -17.69-17.69v-17.67h425v17.67a17.71 17.71 0 0 1 -17.73 17.69zm-401.27-29.36v11.67a11.7 11.7 0 0 0 11.69 11.69h389.58a11.7 11.7 0 0 0 11.69-11.69v-11.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.17 206.04h45.84v15.52h-45.84z",
    transform: "matrix(.707 -.707 .707 .707 -89.94 210.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.33 190.88h15.52v45.84h-15.52z",
    transform: "matrix(.707 -.707 .707 .707 -89.94 210.47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.09 271.46h75.45v15.52h-75.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.62 206.04h45.84v15.52h-45.84z",
    transform: "matrix(.707 -.707 .707 .707 -67.84 263.82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.78 190.88h15.52v45.84h-15.52z",
    transform: "matrix(.707 -.707 .707 .707 -67.84 263.82)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 418.13,
    cy: 133.71,
    fill: "#f5f5f5",
    r: 57.87
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.13,
    cy: 133.71,
    fill: "#f5f5f5",
    r: 57.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.12 358.84h-30.44v-58.67h-16.79l-11.36-11.36 4.24-4.24 9.6 9.6h20.31v34.53l26.5 25-2.06 2.18zm-24.44-6h16.88l-16.88-15.84z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.66 147.89 2.16 27.93a47.77 47.77 0 0 1 -24.14.31l2.18-28.25a26.92 26.92 0 0 1 -1.52-49.4v21.83l11.44 7.63 11.43-7.63v-21.82a26.91 26.91 0 0 1 -1.55 49.4z",
    fill: "#e1830e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.13 194.58a60.87 60.87 0 1 1 60.87-60.87 60.94 60.94 0 0 1 -60.87 60.87zm0-115.73a54.87 54.87 0 1 0 54.87 54.86 54.93 54.93 0 0 0 -54.87-54.86z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.93 194.23-16.53-16.54v-27.56l-35.72-35.71h36.43v27.94l5.29 5.29v27.56l14.77 14.79zm-37.77-73.81 16 15.94v-15.94z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.15 240.68h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6zm-16 0h-6v-6h6z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.75 240.41h-6v-6h6zm-16 0h-6v-6h6z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.84 240.5h-6v-6h6zm0-16h-6v-6h6zm0-16h-6v-6h6zm0-16h-6v-6h6z",
    fill: "#a9afc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.79 420.86a11.86 11.86 0 1 1 11.86-11.86 11.87 11.87 0 0 1 -11.86 11.86zm0-17.71a5.86 5.86 0 1 0 5.86 5.85 5.86 5.86 0 0 0 -5.86-5.85z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.68 439.15a9.74 9.74 0 1 1 9.74-9.73 9.74 9.74 0 0 1 -9.74 9.73zm0-13.47a3.74 3.74 0 1 0 3.74 3.74 3.74 3.74 0 0 0 -3.74-3.74z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.73 90.64h6v19.42h-6z",
    fill: "#5e6175",
    transform: "matrix(.707 -.707 .707 .707 -53.76 70.92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 120.23h19.42v6h-19.42z",
    fill: "#5e6175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.43 77.09h6v19.42h-6z",
    fill: "#5e6175"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceDesign);
export default __webpack_public_path__ + "static/media/interface-design.6b24d66f8d006d562776b0416d46c155.svg";
export { ForwardRef as ReactComponent };